import ResortLandingPage from "@/components/ResortLandingPage";

const SanteVivreExperience = () => {
  return (
    <ResortLandingPage
      developmentSlug="sante-vivre-experience"
      title="Sante Vivre L Experience"
      subtitle="Sofisticacao e bem-estar em Buzios, com proposta inspirada na riviera francesa e no lifestyle do litoral fluminense."
      cityState="Buzios/RJ"
      description="O Sante Vivre L Experience oferece uma proposta premium com suites amplas, area de lazer, spa e estrutura para viagens a dois ou em familia. A localizacao proxima a Geriba facilita o acesso as principais praias e experiencias da cidade."
      bannerPath="/empreendimentos/sante-vivre-banner.jpg"
      galleryPaths={[
        "/empreendimentos/sante-vivre-banner.jpg",
        "/empreendimentos/sante-vivre-galeria-1.jpg",
        "/empreendimentos/sante-vivre-galeria-2.jpg",
      ]}
      address="Estrada Canto Esquerdo de Geriba"
      bookingPhone="0800 300 6565"
      whatsapp="(62) 3773-9600"
      email="reservas@gavresorts.com.br"
    />
  );
};

export default SanteVivreExperience;
